import '../wiring/coreExtensionData.esm.js';
import 'zod';
import 'zod-to-json-schema';
import { createExtensionDataRef } from '../wiring/createExtensionDataRef.esm.js';
import { createExtensionBlueprint } from '../wiring/createExtensionBlueprint.esm.js';

const factoryDataRef = createExtensionDataRef().with({
  id: "core.api.factory"
});
const ApiBlueprint = createExtensionBlueprint({
  kind: "api",
  attachTo: { id: "root", input: "apis" },
  output: [factoryDataRef],
  dataRefs: {
    factory: factoryDataRef
  },
  *factory(params) {
    yield factoryDataRef(params.factory);
  }
});

export { ApiBlueprint };
//# sourceMappingURL=ApiBlueprint.esm.js.map
